import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { ICON } from '@core/util/icon';
import { Matter } from '@models/matter';
import { MatterRepo } from '@repos/matter/matter.repo';
import { Observable } from 'rxjs';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { MultipurposeNavigationService } from '@services/nav/multipurpose-navigation.service';
import { TestHooks } from './appointments.hooks';

@Component({
	selector: 'app-appointments',
	templateUrl: './appointments.component.html',
	styleUrls: ['./appointments.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class GlobalAppointmentsComponent implements OnInit {
	testHooks = TestHooks;
	public appointments$!: Observable<Matter[]>;

	// number of days in advance to show
	@Input() public daysToShowIncludingToday = 7;

	public ICON = ICON;

	// the number of prior to "now" to use (eg, its 3pm, and we want to show stuff from 2:30, set it to 30)
	@Input() public startOffsetMinutes = 59;

	@Output() onClose: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		private matterRepo: MatterRepo,
		private analytics: AnalyticsService,
		private navService: MultipurposeNavigationService,
	) {}

	ngOnInit(): void {
		const now = new Date();
		const start = new Date(now).setMinutes(
			now.getMinutes() - this.startOffsetMinutes,
		);
		const end = new Date(
			new Date().setDate(now.getDate() + this.daysToShowIncludingToday),
		).setHours(24, 0, 0, -1);

		this.appointments$ = this.matterRepo.appointmentsByTimeRange$(start, end);
	}

	goToMatter(matterId: string) {
		this.analytics.logEvent(
			AnalyticsEvent.GLOBAL_SIDE_NAV_APPOINTMENTS_MATTER_CLICK,
			{ matterId: matterId },
		);
		this.navService.goToMatter(matterId);
		this.onClose.emit();
	}
}
